module.exports = __webpack_public_path__ + "media/club_product_v2/8-915d7e77.webp";